import {
  FormFooter as BaseFormFooter,
  FormFooterCancel,
  FormFooterSubmit,
} from 'components';
import { useFormPrompt } from 'hooks';
import { ROUTES, useNavigate } from 'libs/navigation';

import { useFormContext } from '../../forms/createClientForm';

export const FormFooter = ({ submitLoading }: { submitLoading: boolean }) => {
  const { dirty } = useFormContext();
  const { canGoBack, goBack, navigate } = useNavigate();

  useFormPrompt();

  const navigateBack = () => {
    if (canGoBack) {
      goBack();
    } else {
      navigate(ROUTES.clients.personClients.fullPath, {});
    }
  };

  return (
    <BaseFormFooter>
      <FormFooterCancel onClick={navigateBack} />
      <FormFooterSubmit disabled={!dirty} loading={submitLoading} />
    </BaseFormFooter>
  );
};
